import { StaticQuery, graphql } from "gatsby";
import React from "react";

import {
  Section,
  Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

export const Solar = () => (
  <Section
    css={`
      @media screen and (min-width: ${getSize("tablet720")}) {
        justify-content: flex-end;
      }
    `}
  >
    <StaticQuery
      query={graphql`
        query ApplicationsSolarHeroImageQuery {
          file(relativePath: { eq: "solar_worker.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt=""
          css={`
            + picture > img,
            img {
              object-position: 8% 50%;
              @media screen and (min-width: ${getSize("tablet720")}) {
                object-position: 15% 50%;
              }
            }
          `}
          file={file}
        />
      )}
    />
    <Card
      css={`
        @media screen and (min-width: ${getSize(
            "default"
          )}) and (max-width: 479px) {
          padding: 31px 28px 36px 38px;
        }
        @media screen and (min-width: ${getSize(
            "mobile480"
          )}) and (max-width: 719px) {
          padding: 32px 46px 42px 46px;
        }
        @media screen and (min-width: ${getSize(
            "tablet960"
          )}) and (max-width: 1199px) {
          padding: 30px 26px 34px 40px;
          width: 345px;
        }
        @media screen and (min-width: ${getSize(
            "desktop1200"
          )}) and (max-width: 1919px) {
          padding: 44px 48px 44px 50px;
          width: 493px;
        }
        @media screen and (min-width: ${getSize("desktop1920")}) {
          padding-right: 96px;
          width: 568px;
        }
      `}
    >
      <Header2
        id="solar"
        css={`
          @media screen and (min-width: ${getSize("desktop1200")}) {
            font-size: 48px;
            line-height: 58px;
          }
        `}
      >
        {"Solar"}
        <Underlined />
      </Header2>
      <Paragraph
        css={`
          @media screen and (min-width: ${getSize(
              "default"
            )}) and (max-width: 479px) {
            margin-top: 22px;
          }
          @media screen and (min-width: ${getSize(
              "mobile480"
            )}) and (max-width: 767px) {
            margin-top: 20px;
          }
          @media screen and (min-width: ${getSize(
              "tablet960"
            )}) and (max-width: 1199px) {
            margin-top: 22px;
          }
          @media screen and (min-width: ${getSize(
              "desktop1200"
            )}) and (max-width: 1919px) {
            font-size: 20px;
            line-height: 31px;
            margin-top: 19px;
          }
        `}
      >
        {
          "We provide quality solar products, installation and support, with competitive pricing utilizing industry leading solar products, top installers, engineers and 20+ years of solar industry knowledge. Savant Power offers free consultation and is a NABCEP Solar PV Certified Installer."
        }
      </Paragraph>
    </Card>
  </Section>
);
